<template>
  <div class="upgrade-membership relative" v-if="showView">
    <div class="upgrade-membership-img">
      <img :src="imgUrl" alt="upgrade membership" />
    </div>
    <div class="upgrade-membership-box">
      <div class="title">{{ t("shell.home.upgradeMembership.title") }}</div>
      <div class="entry-box">
        <div class="entry">
          <div
            class="entry-item flex items-center cursor-pointer"
            v-for="(item, index) in entryList"
            :key="index"
            :class="{ 'mb-8': index !== entryList.length - 1 }"
            @click="handleOnClick(item.url)"
          >
            <div class="flex items-center flex-1">
              <img :src="item.icon" class="w-5 mr-4" alt="" />
              {{ item.text }}
            </div>
            <IconifyIconOnline
              style="transform: translateY(3px)"
              icon="material-symbols:arrow-right-rounded"
              width="20"
              height="20"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="upgrade-membership-img">
      <img :src="imgUrl" alt="upgrade membership" />
      <div class="title">{{ t("shell.home.upgradeMembership.title") }}</div>
    </div>
    <div class="entry-box">
      <div class="entry">
        <div
          class="entry-item flex items-center cursor-pointer"
          v-for="(item, index) in entryList"
          :key="index"
          :class="{ 'mb-11': index !== entryList.length - 1 }"
          @click="handleOnClick(item.url)"
        >
          <div class="flex items-center flex-1">
            <img :src="item.icon" class="w-6 mr-4" alt="" />
            {{ item.text }}
          </div>
          <IconifyIconOnline
            icon="material-symbols:arrow-right-rounded"
            width="24"
            height="24"
          />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import IconCreditCard from "@consumerY/assets/icon/credit-card.png";
import IconAirline from "@consumerY/assets/icon/icon-airline.png";
import lodash from "lodash";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { useUserStoreHook } from "@/store/modules/user";
import { optimizeQiniuImage } from "@/utils/tool";

const { t } = useI18n();
const router = useRouter();
const userStore = useUserStoreHook();
const { user } = storeToRefs(userStore);

const imgUrl = optimizeQiniuImage("https://uploads.ytripos.com/pic.webp");

const showView = computed(() => {
  const level = lodash.get(user.value, "loyaltyProgram.ref.type", "");
  return !level || level === "guest";
});

const entryList = computed(() => [
  {
    text: t("shell.home.upgradeMembership.byCard"),
    icon: IconCreditCard,
    url: "/credit-card-match"
  },
  {
    text: t("shell.home.upgradeMembership.byAirline"),
    icon: IconAirline,
    url: "/airline-match"
  }
]);

const handleOnClick = url => {
  router.push(url);
};

defineOptions({
  name: "UpgradeMembership"
});
</script>

<style scoped lang="scss">
.upgrade-membership {
  margin: 100px auto 100px;
  width: 1080px;
  height: 360px;
  display: flex;
  &-img {
    width: 50%;
    height: 100%;
  }
  &-img img {
    width: 100%;
    height: 100%;
  }
  &-box {
    width: 50%;
    background-color: var(--y-background-color);
  }
  .title {
    text-align: center;
    font-family: Cormorant-Bold;
    font-weight: bold;
    font-size: 36px;
    line-height: 36px;
    color: #292929;
    padding-top: 70px;
    padding-bottom: 96px;
  }
  .entry-box {
    // width: 380px;
    width: 100%;
    height: 20px;
    // position: absolute;
    // right: 40px;
    // bottom: -86px;
    // background: #ffffff;
    // border-bottom: 4px solid #000b1e;
    padding: 0 80px;
    // box-shadow: 0 0 27px 0 rgba(0, 0, 0, 0.1);
    .entry-item {
      font-family: var(--y-regular-font);
      // font-weight: bold;
      font-size: 20px;
      color: var(--y-title-text-color);
      line-height: 20px;
    }
  }
}
</style>
